import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";

import { AuthService } from "./../../services/auth.service";
import { UserModel } from "../../models/user/user.model";
import { DistinteIncassiService } from "../../services/distinte-incassi.service";
import { BrogliacciService } from "../../services/brogliacci.service";
import { LangService } from "../../services/lang.services";
import { UltimaVersioneApplicativoClientService } from "../../services/ultima-versione-applicativo-client.service";
import { Configurations } from "../../core/configurations";
import { DashboardService } from "../../services/dashboard.service";
import { BloccoModel } from "../../models/dashboard/blocco.model";
import { SharedService } from "../../services/shared.service";

import * as _ from "lodash";
import { DizionarioModel } from "../../models/shared/dizionario.model";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  user: UserModel;
  isLoading: boolean;
  // countBrogliacciDaLavorare: number = 0;
  // countDistIncassiDaLavorare: number = 0;

  constructor(
    public _authService: AuthService,
    private _langService: LangService,
    private _ultimaVersioneClientTipo: UltimaVersioneApplicativoClientService,
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) {
    this.user = this._authService.user;
  }

  rowHeight: string;
  size: any;
  dashboardContent: Array<BloccoModel> = [];

  ngOnInit() {
    this._authService
      .listaUnitaVendita()
      .subscribe((res: DizionarioModel[]) => {
        // const ordered = _.orderBy(res, ["descrizione"]);
        localStorage.setItem("listaUnitaVendita", JSON.stringify(res));
        this._sharedService.setUvZoneList(true);
      });
    this._langService.setLang("it");
    this.isLoading = true;
    this._dashboardService.getSliders().subscribe((sliders) => {
      const currentSlider = sliders.find(
        (page) => page.nomeSlider === "Homepage"
      );

      this.getAuthManItem((ruolo) => {
        this._dashboardService
          // .getSlider(currentSlider.token)
          .getSlider(currentSlider.token, false, ruolo)
          .finally(() => (this.isLoading = false))
          .subscribe(
            (homepageSlider) => {
              this.dashboardContent = _.orderBy(homepageSlider.blocchiInfo, [
                "ordine",
              ]);
              this.size = homepageSlider.colonneSlider;
              this.rowHeight = `${homepageSlider.righeSlider}px`;
              //save Slider on shared
              this._sharedService.setSlider(homepageSlider);
              this.onResize();
              this.isLoading = false;
            },
            (err) => {}
          );
      });
    });

    this._ultimaVersioneClientTipo
      .getUltimaVersioneApplicativo()
      .subscribe((data) => {
        Configurations.currentVersionCod = data.codice;
        let v = localStorage.getItem("clientVersion");
        if (v === null || v === undefined || v !== data.codice) {
          localStorage.setItem("clientVersion", data.codice);
          alert(
            "Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage."
          );
          window.location.href = Configurations.baseUrl;
        }
        // this.isLoading = false;
      });
  }

  hasPermission(permName: string) {
    return this._authService.isGranted(permName);
  }

  onResize() {
    this.resizeGrid();
  }

  resizeGrid = () => {
    const widthForCheck = window.innerWidth;
    this.dashboardContent.forEach((item) => {
      if (widthForCheck > 768) {
        item.cols = item.colonneBlocco;
      }
      if (widthForCheck > 425 && widthForCheck <= 768) {
        item.cols =
          item.colonneBlocco >= this.size / 2
            ? this.size
            : Math.ceil(this.size / 2);
      }
      if (widthForCheck <= 425) {
        item.cols = this.size;
      }
    });
  };

  getAuthManItem = (method) => {
    this._dashboardService
      .getAuthManItems()
      .subscribe((authManItems: Array<any>) => {
        const ruolo = this.user.authorizations.find((item) => {
          return authManItems.find((auth) => auth.name === item);
        });
        method(ruolo);
      });
  };
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/dashboard/dashboard.component.ts